/**
 * Generates a linear gradient string with specified start and end opacity values
 * Uses a fixed gradient direction (148deg) and positions (2.08%, 76.85%) as per design specs
 *
 * @param startOpacity - Starting opacity percentage (0-100)
 * @param endOpacity - Ending opacity percentage (0-100)
 * @returns CSS linear-gradient string
 */
export const generateGradient = (
  startOpacity: number,
  endOpacity: number
): string => {
  const startOpacityDecimal = startOpacity / 100;
  const endOpacityDecimal = endOpacity / 100;

  return `linear-gradient(148deg, rgba(0, 0, 0, ${startOpacityDecimal}) 2.08%, rgba(0, 0, 0, ${endOpacityDecimal}) 76.85%)`;
};
